import React from "react";

const StoryCard = () => {
  return (
    <div className="stories-img color">
      <img
        src="https://images.unsplash.com/photo-1688607932168-f4d050f372c9?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxleHBsb3JlLWZlZWR8M3x8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=60"
        alt=""
      />
    </div>
  );
};

export default StoryCard;
